import {Action} from '@ngrx/store';
import {type} from '../utilities/type';

export const headerTitleActionTypes = {
  UPDATE: type('[Header title] Update'),
  CLEAR: type('[Header title] Clear'),
};

export class HeaderTitleAction implements Action {
  readonly type = headerTitleActionTypes.UPDATE;
  constructor(public payload?: {title: string , icon: string}) {}
}

export class HeaderTitleClearAction implements Action {
  readonly type = headerTitleActionTypes.CLEAR;
  constructor() {}
}


